import { createSelector, createSlice } from "@reduxjs/toolkit";

import { IPermission } from "@/models/onboarding";

import { RootState } from "../store";

const fetchRolePermissionSlice = createSlice({
  name: "fetchRolePermission",
  initialState: {
    permission: [] as IPermission[],
    showAlert: false as boolean,
  },
  reducers: {
    setRoleAndPermission: (state, action) => {
      state.permission = action.payload;
    },
    setShowPermissionAlert: (state) => {
      state.showAlert = !state.showAlert;
    },
    setShowPermission: (state, action) => {
      state.showAlert = action.payload;
    },
  },
});

const rolePermissionInfo = (state: RootState) => state.rolePermission;

export const rolePermission = createSelector(
  [rolePermissionInfo],
  (rolePermission) => {
    return {
      permission: rolePermission.permission,
      showAlert: rolePermission.showAlert,
    };
  }
);

export const {
  setRoleAndPermission,
  setShowPermissionAlert,
  setShowPermission,
} = fetchRolePermissionSlice.actions;
export default fetchRolePermissionSlice.reducer;
